<template>
    <f7-page class="page-shortcode-create">
        <f7-navbar :sliding="false">
            <f7-nav-left back-link="Trở lại"></f7-nav-left>
            <f7-nav-title sliding>CHỈNH SỬA CÚ PHÁP</f7-nav-title>
        </f7-navbar>
        <f7-list inset class="mb-2">
            <f7-list-input
                outline
                floating-label
                label="Cú pháp"
                type="text"
                :value="form_edit.shortcode"
                @input="form_edit.shortcode = $event.target.value">
            </f7-list-input>
            <f7-list-input
                outline
                floating-label
                label="Số thay thế"
                type="textarea"
                :value="form_edit.result"
                @input="form_edit.result = $event.target.value">
            </f7-list-input>
        </f7-list>
        <f7-block class="mt-0">
            <f7-row>
                <f7-col>
                    <f7-button fill color="red" @click.prevent="removeShortcode">
                        XÓA
                    </f7-button>
                </f7-col>
                <f7-col>
                    <f7-button fill color="green" @click.prevent="submitFormEdit">
                        LƯU CÚ PHÁP
                    </f7-button>
                </f7-col>
            </f7-row>
        </f7-block>
    </f7-page>
</template>
<script>

export default {
    props     :{
        id       :Number,
        shortcode:String,
        result   :String
    },
    data(){
        return {
            form_edit:{
                id       :'',
                shortcode:'',
                result   :''
            }
        }
    },
    methods   :{
        submitFormEdit(){
            this.$f7.dialog.preloader();

            this.$store.dispatch('editShortcode', this.form_edit)
                .then(() => {
                    return this.$store.dispatch('getShortcodes');
                })
                .then(() => {
                    this.$f7.dialog.close();
                    this.$f7.dialog.alert('Chỉnh sửa cú pháp thành công!', 'SUCCESS!', () => {
                        this.$f7.views.main.router.back();
                    });
                })
                .catch((err) => {
                    this.$f7.dialog.close();
                    this.$f7.dialog.alert(err, 'LỖI!');
                })
        },
        removeShortcode(){
            this.$f7.dialog.preloader();

            this.$store.dispatch('removeShortcode', this.form_edit)
                .then(() => {
                    return this.$store.dispatch('getShortcodes');
                })
                .then(() => {
                    this.$f7.dialog.close();
                    this.$f7.dialog.alert('Đã xóa cú pháp!', 'SUCCESS!', () => {
                        this.$f7.views.main.router.back();
                    });
                })
                .catch((err) => {
                    this.$f7.dialog.close();
                    this.$f7.dialog.alert(err, 'LỖI!');
                })
        }
    },
    mounted(){
        this.form_edit.id = this.id;
        this.form_edit.shortcode = this.shortcode;
        this.form_edit.result = this.result;
    }
};
</script>
